import { createContext, useContext } from 'react';

export const ColorModeContext = createContext({
  mode: '',
  toggleColorMode: () => null,
});

export const useColorMode = () => useContext(ColorModeContext);
export const ColorModeConsumer = ColorModeContext.Consumer;
